
export default function Footer() {
  return (
    <footer className="bg-deep-black py-10 md:py-16 px-4 md:px-6" style={{ color: '#ede8d8' }}>
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row items-start justify-between mb-8 md:mb-12 pb-8 md:pb-12 border-b border-champagne-gold/20 gap-4">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div
                className="text-2xl md:text-3xl font-cinzel tracking-widest"
                style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}
              >
                WEI CHEN
              </div>
            </div>
            <p
              className="font-cormorant text-xs md:text-sm max-w-md"
              style={{ color: '#ede8d8', opacity: 0.55 }}
            >
              Dedicated to Vocal Arts&nbsp; |&nbsp; 致力于声乐艺术
            </p>
          </div>
        </div>

        {/* Middle Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div>
            <h4 className="font-playfair text-sm md:text-base mb-3 md:mb-4" style={{ color: '#c9a84c' }}>
              Performances
            </h4>
            <ul className="space-y-1.5 md:space-y-2">
              {[
                { label: 'Repertoire', href: '/#repertoire' },
                { label: 'Performance Videos', href: '/#videos' },
                { label: 'Upcoming Dates', href: '#' },
                { label: 'Past Performances', href: '#' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="font-cormorant text-xs md:text-sm transition-colors duration-300 cursor-pointer hover:opacity-100"
                    style={{ color: '#ede8d8', opacity: 0.55 }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-playfair text-sm md:text-base mb-3 md:mb-4" style={{ color: '#c9a84c' }}>
              Media
            </h4>
            <ul className="space-y-1.5 md:space-y-2">
              {[
                { label: 'Photo Gallery', href: '/gallery' },
                { label: 'Press Coverage', href: '#' },
                { label: 'Press Kit', href: '#' },
                { label: 'Interviews', href: '#' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="font-cormorant text-xs md:text-sm transition-colors duration-300 cursor-pointer hover:opacity-100"
                    style={{ color: '#ede8d8', opacity: 0.55 }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-playfair text-sm md:text-base mb-3 md:mb-4" style={{ color: '#c9a84c' }}>
              About
            </h4>
            <ul className="space-y-1.5 md:space-y-2">
              {[
                { label: 'Biography', href: '/#about' },
                { label: 'Résumé', href: '/resume' },
                { label: 'Contact', href: '/#contact' },
                { label: 'Collaborations', href: '#' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="font-cormorant text-xs md:text-sm transition-colors duration-300 cursor-pointer hover:opacity-100"
                    style={{ color: '#ede8d8', opacity: 0.55 }}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-left md:text-right">
            <div className="font-playfair text-base md:text-lg mb-1 md:mb-2" style={{ color: '#c9a84c' }}>
              © Wei Chen 2026
            </div>
            <div className="font-cormorant text-xs mb-3 md:mb-4" style={{ color: '#ede8d8', opacity: 0.4 }}>
              All Rights Reserved
            </div>
            <div className="flex items-center md:justify-end gap-3 flex-wrap">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/weichen_victor/' },
                { icon: 'ri-youtube-line', label: 'YouTube', href: 'https://www.youtube.com/@VicVII' },
                { icon: 'ri-facebook-line', label: 'Facebook', href: 'https://www.facebook.com/wei.chen.980156/' },
                { icon: 'ri-linkedin-line', label: 'LinkedIn', href: '#' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.href !== '#' ? '_blank' : undefined}
                  rel={s.href !== '#' ? 'nofollow noopener noreferrer' : undefined}
                  className="transition-colors duration-300 cursor-pointer hover:opacity-100"
                  style={{ color: '#c9a84c', opacity: 0.85 }}
                  title={s.label}
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base md:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-6 md:pt-8 border-t border-champagne-gold/20">
          <div className="text-center font-cormorant text-xs md:text-sm" style={{ color: '#ede8d8', opacity: 0.4 }}>
            All content © Wei Chen. Professional classical baritone based in New York.
          </div>
        </div>
      </div>
    </footer>
  );
}
